import styled from "styled-components";
import { defaults, colors } from "../../../../styles";

export const Container = styled(defaults.Container)`
  flex: 1;
  flex-direction: row;
  height: 100%;
  max-height: 175px;
  flex-wrap: wrap;
`;

export const NPSLabel = styled(defaults.Label)`
  flex: 1;
  text-align: center;
  height: 40px;
  width: 40px;
  max-width: 40px;
  min-width: 40px;
  color: ${colors.white};
  font-weight: bold;
  margin: 4px;
  border-radius: 5px;
  padding: 10px;

  background-color: ${props => props.bgColor};

  opacity: ${({ checked, selected }) =>
    checked || (selected === 0 ? selected : !selected)
      ? 1
      : defaults.opacityNotSelected};
`;
